import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import {Hidden, Icon, IconButton, TextField, Typography} from '@material-ui/core';
import {FuseAnimate} from "../../../../@fuse";
import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxVip from "../../../../store/actionreducers/vip";
import ReduxGroup from "../../../../store/actionreducers/group";
import ReduxGroupType from "../../../../store/actionreducers/groupType";
import ReduxCompany from "../../../../store/actionreducers/company";
import ReduxMissionType from "../../../../store/actionreducers/missionPriceType";
import CompanyVipSidebarContent from './CompanyVipSidebarContent';
import CompanyVipList from './CompanyVipList';
import VipDialog from './CompanyVipDialog';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import UseRecordDialog from "../vip/UseRecordDialog";
import JoinClubDialog from "../vip/JoinClubDialog";

class CompanyVipApp extends Component {

    async componentDidMount() {
        try {
            await this.props.getCompanyVips();
            await this.props.getCompanies();
            await this.props.getGroupTypes();
            await this.props.getMissionPriceTypes();
            this.props.setCompany({});

            let event = {target: {value: ''}};
            this.props.setSearchText(event);
            this.props.setSidebarSearchText(event);
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    render() {
        const {classes, setSidebarSearchText, sidebarSearchText, searchText, setSearchText} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">
                        <div className="flex items-center justify-between">
                            <Hidden lgUp>
                                <IconButton
                                    onClick={(ev) => this.pageLayout.toggleLeftSidebar()}
                                    aria-label="open left sidebar"
                                >
                                    <Icon>menu</Icon>
                                </IconButton>
                            </Hidden>
                            <div>
                                <Typography variant="title">
                                    公司 ({this.props.company && this.props.company.name}) > 會員列表
                                </Typography>
                            </div>
                        </div>
                        <div className="flex items-center">

                            <FuseAnimate animation="transition.expandIn" delay={300}>
                                <Icon color="action">search</Icon>
                            </FuseAnimate>

                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <TextField
                                    placeholder="搜尋"
                                    className="pl-16"
                                    fullWidth
                                    value={searchText}
                                    inputProps={{
                                        'aria-label': 'Search'
                                    }}
                                    onChange={setSearchText}
                                />
                            </FuseAnimate>
                        </div>
                    </div>
                }
                content={
                    <div className="p-24">
                        <CompanyVipList/>
                        {/*<FuseAnimate animation="transition.expandIn" delay={300}>*/}
                        {/*    <Button*/}
                        {/*        disabled={!(this.props.company && this.props.company.id)}*/}
                        {/*        variant="fab"*/}
                        {/*        color="primary"*/}
                        {/*        aria-label="add"*/}
                        {/*        className={classes.addButton}*/}
                        {/*        onClick={this.props.openNewDataDialog}*/}
                        {/*    >*/}
                        {/*        <Icon>person_add</Icon>*/}
                        {/*    </Button>*/}
                        {/*</FuseAnimate>*/}
                        <VipDialog/>
                        <UecareAlertDialog/>
                        <UseRecordDialog/>
                        <JoinClubDialog/>
                    </div>
                }
                leftSidebarHeader={
                    <div className="p-24">
                        <h4>公司</h4>
                        <div className="flex items-center">

                            <FuseAnimate animation="transition.expandIn" delay={300}>
                                <Icon color="action">search</Icon>
                            </FuseAnimate>

                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <TextField
                                    placeholder="搜尋"
                                    className="pl-16"
                                    fullWidth
                                    value={sidebarSearchText}
                                    inputProps={{
                                        'aria-label': 'Search'
                                    }}
                                    onChange={setSidebarSearchText}
                                />
                            </FuseAnimate>
                        </div>
                    </div>
                }
                leftSidebarContent={<CompanyVipSidebarContent/>}
                innerScroll
                onRef={instance => {
                    this.pageLayout = instance;
                }}
            />
        )
    };
}

const styles = theme => ({
    addButton: {
        position: 'fixed',
        right: 12,
        bottom: 12,
        zIndex: 99
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompanyVips: ReduxVip.ActionCreator.getCompanyVips,
        getCompanies: ReduxCompany.ActionCreator.getCompanies,
        getGroupTypes: ReduxGroupType.ActionCreator.getGroupTypes,
        getMissionPriceTypes: ReduxMissionType.ActionCreator.getMissionPriceTypes,
        openNewDataDialog: ReduxGlobal.ActionCreator.openNewDataDialog,
        setCompany: ReduxCompany.ActionCreator.setCompany,
        setSearchText: ReduxGlobal.ActionCreator.setSearchText,
        setSidebarSearchText: ReduxGlobal.ActionCreator.setSidebarSearchText,
    }, dispatch);
}

function mapStateToProps({company: {company}, contactsApp, global: {searchText, sidebarSearchText}}) {
    return {
        company,
        searchText,
        sidebarSearchText,
    };
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyVipApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/companyVip/CompanyVipApp.js